import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FaIconLibrary,
  FontAwesomeModule,
} from '@fortawesome/angular-fontawesome';
import {
  faPowerOff,
  faTrash,
  faPlusCircle,
  faSearch,
  faArrowLeft,
  faBars,
  faQuestionCircle,
  faSpinner,
  faSort,
  faEye,
  faPencilAlt,
  faMinus,
  faHome,
  faPlus,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { RouterModule } from '@angular/router';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatRadioModule } from '@angular/material/radio';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {
  ModalLogoutComponent,
  ContentHeaderComponent,
  ContentListComponent,
  ModalConfirmComponent,
  LoadingComponent,
  LoadingGlobalComponent,
} from './components';
import {
  AppExpandMenu,
  AppExpandSidebar,
  FilterGeneralPipe,
  SearchPipe,
  OrderByPipe,
} from './pipes';
import { ComboBoxLoadingComponent } from './components/combo-box-loading/combo-box-loading.component';
import { TranslateModule } from '@ngx-translate/core';
import { FilesTableComponent } from './components/files-table/files-table.component';
import { CreateComponent } from './components/modal/create/create.component';
import { SaveComponent } from './components/modal/save/save.component';
import { UpdateComponent } from './components/modal/update/update.component';
import { ResultComponent } from './components/modal/result/result.component';

@NgModule({
  imports: [
    CommonModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgxPaginationModule,
    TranslateModule,
    MatExpansionModule,
    MatGridListModule,
    MatTableModule,
    MatSortModule,
    MatRadioModule,
    NgbModule,
  ],
  declarations: [
    ModalLogoutComponent,
    AppExpandMenu,
    AppExpandSidebar,
    ContentHeaderComponent,
    ContentListComponent,
    FilterGeneralPipe,
    SearchPipe,
    ModalConfirmComponent,
    OrderByPipe,
    LoadingComponent,
    LoadingGlobalComponent,
    ComboBoxLoadingComponent,
    FilesTableComponent,
    CreateComponent,
    SaveComponent,
    UpdateComponent,
    ResultComponent,
  ],
  exports: [
    ModalLogoutComponent,
    AppExpandMenu,
    AppExpandSidebar,
    ContentHeaderComponent,
    ContentListComponent,
    FilterGeneralPipe,
    SearchPipe,
    ModalConfirmComponent,
    OrderByPipe,
    LoadingComponent,
    LoadingGlobalComponent,
    FilesTableComponent,
    CreateComponent,
    SaveComponent,
    UpdateComponent,
    ResultComponent,
  ],
  entryComponents: [ModalLogoutComponent, ModalConfirmComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(
      faPowerOff,
      faTrash,
      faPlusCircle,
      faSearch,
      faArrowLeft,
      faBars,
      faQuestionCircle,
      faSpinner,
      faSort,
      faEye,
      faPencilAlt,
      faMinus,
      faHome,
      faPlus,
      faTimes
    );
  }
}
